export default "__VITE_ASSET__DlYP3MMK__"